import { ducxMainnet, ducxTestnet } from './networks/custom-networks'

/*
 * SupportedChainId must be defined inline, without using @uniswap/sdk-core, so that its members are their own types
 * {@see https://www.typescriptlang.org/docs/handbook/enums.html#union-enums-and-enum-member-types}. This allows the
 * derived const arrays and their types (eg {@link L1_CHAIN_IDS}, {@link SupportedL1ChainId}) to be narrowed and used
 * to enforce chain typing.
 *
 * Because this is not explicitly derived from @uniswap/sdk-core, there is a unit test to enforce conformance.
 */
export enum SupportedChainId {
  DUCX = ducxMainnet.id,
  DUCX_TESTNET = ducxTestnet.id,
}

export const DEFAULT_CHAIN_ID = SupportedChainId.DUCX

export const CHAIN_IDS_TO_NAMES = {
  [SupportedChainId.DUCX]: 'ducx_mainnet',
  [SupportedChainId.DUCX_TESTNET]: 'ducx_testnet',
}

/**
 * Array of all the supported chain IDs
 */
export const ALL_SUPPORTED_CHAIN_IDS: SupportedChainId[] = [ducxMainnet.id]
//   Object.values(SupportedChainId).filter(
//   (id) => typeof id === 'number'
// ) as SupportedChainId[]

export function isSupportedChain(chainId: number | null | undefined): chainId is SupportedChainId {
  return !!chainId && !!SupportedChainId[chainId]
}

export const SUPPORTED_GAS_ESTIMATE_CHAIN_IDS = [SupportedChainId.DUCX_TESTNET, SupportedChainId.DUCX] as const

/**
 * All the chain IDs that are running the Ethereum protocol.
 */
export const L1_CHAIN_IDS = [SupportedChainId.DUCX_TESTNET, SupportedChainId.DUCX] as const

export type SupportedL1ChainId = (typeof L1_CHAIN_IDS)[number]

/**
 * Controls some L2 specific behavior, e.g. slippage tolerance, special UI behavior.
 * The expectation is that all of these networks have immediate transaction confirmation.
 */
export const L2_CHAIN_IDS = [] as const

export type SupportedL2ChainId = (typeof L2_CHAIN_IDS)[number]
